import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CreateEmissionFactorDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EMISSION_FACTORS } from "../domain";

import { emissionFactorsApi } from "@api/services";
import { ACTION_GET_EMISSION_FACTORS, roleGuard } from "@api";

export const ACTION_CREATE_EMISSION_FACTOR = "CREATE_EMISSION_FACTOR";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const createEmissionFactor = async (req: CreateEmissionFactorDto): Promise<void> => {
  await emissionFactorsApi.emissionFactorsControllerCreateEmissionFactor(req);
};

export const useCreateEmissionFactor = (
  user: UserProfileDto | null,
): {
  createEmissionFactor: UseMutateFunction<
    void,
    unknown,
    CreateEmissionFactorDto,
    unknown
  >;
  createEmissionFactorEnabled: boolean;
  isSuccessCreateEmissionFactor: boolean;
  isPendingCreateEmissionFactor: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EMISSION_FACTORS, ACTION_CREATE_EMISSION_FACTOR],
    mutationFn: enabled ? createEmissionFactor : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_EMISSION_FACTORS, ACTION_GET_EMISSION_FACTORS],
      });
    },
  });

  return {
    createEmissionFactor: mutate,
    createEmissionFactorEnabled: enabled,
    isSuccessCreateEmissionFactor: isSuccess,
    isPendingCreateEmissionFactor: isPending,
  };
};
